import { populate } from "./render";

export default function initPagination({
    map,
    ajaxUrl,
    templates,
    forceParams,
} = {}) {
    const paginationContainer = $("#pagination-container");
    const listingSection = document.getElementById("listing-section");

    // allow calling with URLSearchParams or string
    const dataSource = (function () {
        if (forceParams) {
            return `${ajaxUrl}?action=search_listings&${forceParams.toString()}`;
        }
        return `${ajaxUrl}?action=search_listings&${window.location.search.replace(
            /^\?/,
            ""
        )}`;
    })();

    const pageSize = document.querySelector('[name="mapSearch"]')?.value
        ? 21
        : 9;

    return paginationContainer.pagination({
        dataSource,
        ajax: {
            beforeSend: function (xhr, data) {
                $("#listing-container").html(
                    `<div class="loading-spinner"><p>Loading...</p></div>`
                );

                let url = new URL(data.url);
                const startParam = +url.searchParams.get("start") || 1;
                url.searchParams.set(
                    "start",
                    ((startParam - 1) * pageSize).toString()
                );
                data.url = url.href;

                window.scrollTo({
                    top: listingSection.offsetTop,
                    behavior: "smooth",
                });
            },
        },
        totalNumberLocator: (response) => response.results_count,
        pageSize,
        hideOnlyOnePage: true,
        locator: "results",
        alias: { pageNumber: "start", pageSize: "limit" },
        callback: (data, pagination) => {
            populate(data);
        },
    });
}
